import { removeElementIndexedDB, removeElementIndexedDBCheckList } from "../functions";

var ModalWarningRemovePhotoCheckList = {
    view: function (ctrl, args) {

        return m('div.dm-overlay',
            m("div.dm-table", [
                m("div.dm-cell", [
                    m("div.dm-modal", [
                        m(".bg-primary[style='padding:10px;z-index:1;']", [
                            m("span", "Удаление фото"),
                            m("span.pull-right[style='cursor: pointer;']", {
                                onclick: ModalContainerWarningRemovePhotoCheckList.close
                            }, [
                                m("i.glyphicon.glyphicon-remove"),
                                m.trust('&nbsp;Закрыть')
                            ])
                        ]),
                        [
                            m("div", [
                                m("div[style='margin: 15px 0; padding: 0 15px;']", [
                                    m("div[style='text-align: center;']", [
                                        m("b[id='titleModalRemovePhoto']", args.data)
                                    ]),
                                    m("br"),
                                    m(".row[style='text-align: center;']", [
                                        m(".col-xs-6", [
                                            m("button.btn.btn-success.btn-lg", {
                                                id: "yesBtnModalRemovePhoto",
                                            }, "Да")
                                        ]),
                                        m(".col-xs-6", [
                                            m("button.btn.btn-danger.btn-lg", {
                                                id: "",
                                                onclick: function () {
                                                    ModalContainerWarningRemovePhotoCheckList.close();
                                                }
                                            }, "Нет")
                                        ])
                                    ]),
                                ])
                            ])
                        ]
                    ])
                ])
            ])
        );
    }
};

export var ModalContainerWarningRemovePhotoCheckList = {
    container: null,
    idElement: null,
    removeAll: null,
    removeDB: null,
    init: function () {
        ModalContainerWarningRemovePhotoCheckList.container = document.querySelector('#ModalWarningRemovePhotoCheckList');
        if (!ModalContainerWarningRemovePhotoCheckList.container) {
            ModalContainerWarningRemovePhotoCheckList.container = document.createElement('div');
            ModalContainerWarningRemovePhotoCheckList.container.id = 'ModalWarningRemovePhotoCheckList';
            ModalContainerWarningRemovePhotoCheckList.container.hidden = true;
            document.body.appendChild(ModalContainerWarningRemovePhotoCheckList.container);

            m.mount(ModalContainerWarningRemovePhotoCheckList.container, m.component(ModalWarningRemovePhotoCheckList, {data:  "", type: false, idElement: ""}));
        }
    },
    open: function (title, removeAll, idElement, removeDB = false) {
        ModalContainerWarningRemovePhotoCheckList.container = document.querySelector('#ModalWarningRemovePhotoCheckList');
        if(typeof(idElement) != "undefined" && idElement !== null)
            ModalContainerWarningRemovePhotoCheckList.idElement = idElement;
        if(typeof(removeAll) != "undefined" && removeAll !== null)
            ModalContainerWarningRemovePhotoCheckList.removeAll = removeAll;

        if (ModalContainerWarningRemovePhotoCheckList.container) {
            document.getElementById("titleModalRemovePhoto").innerText = title;
            document.getElementById("yesBtnModalRemovePhoto").addEventListener("click", function () {
                if(ModalContainerWarningRemovePhotoCheckList.removeAll) {
                    localStorage.setItem("unsavedPhotoCheckList", []);
                    var conteiner = document.getElementById("pictureConteiner");
                    conteiner.innerHTML = "";
                }
                else {
                    if(removeDB) {
                        m.request({
                            method: 'PUT',
                            url: '/api/task/' + m.route.param('taskId') + '/removePhoto',
                            data: ModalContainerWarningRemovePhotoCheckList.idElement
                        }).then(function (response) {
                            var idParent = ModalContainerWarningRemovePhotoCheckList.idElement;
                            removeElementIndexedDB(idParent);
                        }, function () {
                        });
                    }
                    else {
                        var idParent = ModalContainerWarningRemovePhotoCheckList.idElement;
                        removeElementIndexedDBCheckList(idParent);
                    }
                }
                ModalContainerWarningRemovePhotoCheckList.close();
            });
            ModalContainerWarningRemovePhotoCheckList.container.hidden = false;
        }
    },
    close: function () {
        ModalContainerWarningRemovePhotoCheckList.container.hidden = true;
    }
};
